import type {
  TFacesColumns,
  TEventsColumns,
} from '../types';

export const columnsArrayToObject = (
  columnsArr: TFacesColumns[] | TEventsColumns[],
): Partial<Record<TFacesColumns | TEventsColumns, boolean>> => {
  const columnsObj: Partial<Record<TFacesColumns | TEventsColumns, boolean>> = {};

  columnsArr.forEach((key) => {
    columnsObj[key] = true;
  });

  return columnsObj;
};
